(function () {
	const COLLAPSE_MS = 200;
	const EXPAND_MS = 220;
	const COLLAPSE_BUFFER_MS = 48;

	const prefersReducedMotion = () =>
		window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	const clearConceal = (panel) => {
		if (!panel) return;
		if (panel._accordionConcealTimer) {
			window.clearTimeout(panel._accordionConcealTimer);
			panel._accordionConcealTimer = null;
		}
		if (panel._accordionConcealFrame) {
			window.cancelAnimationFrame(panel._accordionConcealFrame);
			panel._accordionConcealFrame = null;
		}
		if (panel._accordionOnEnd) {
			panel.removeEventListener("transitionend", panel._accordionOnEnd);
			panel._accordionOnEnd = null;
		}
	};

	const getCollapseDuration = (panel) => {
		const { transitionDuration } = window.getComputedStyle(panel);
		const durations = transitionDuration
			.split(",")
			.map((value) => parseFloat(value) * 1000)
			.filter((value) => !Number.isNaN(value));

		return Math.max(COLLAPSE_MS, ...durations, 0);
	};

	const isPanelCollapsed = (panel) => {
		if (panel.offsetHeight > 1) return false;

		const inner = panel.querySelector(
			".collapsible-content__answer-inner, .about__accordion-text-inner",
		);

		return !inner || inner.scrollHeight <= 1;
	};

	const waitUntilCollapsed = (panel, callback, deadline) => {
		const tick = () => {
			panel._accordionConcealFrame = null;

			if (isPanelCollapsed(panel) || Date.now() >= deadline) {
				callback();
				return;
			}

			panel._accordionConcealFrame = window.requestAnimationFrame(tick);
		};

		panel._accordionConcealFrame = window.requestAnimationFrame(tick);
	};

	const reveal = (panel, callback) => {
		if (!panel) return;

		clearConceal(panel);
		panel.hidden = false;

		if (prefersReducedMotion()) {
			callback?.();
			return;
		}

		requestAnimationFrame(() => {
			requestAnimationFrame(() => callback?.());
		});
	};

	const conceal = (panel) => {
		if (!panel || panel.hidden) return;

		clearConceal(panel);

		if (prefersReducedMotion()) {
			panel.hidden = true;
			return;
		}

		let finished = false;
		const collapseMs = getCollapseDuration(panel);
		const deadline = Date.now() + collapseMs + COLLAPSE_BUFFER_MS;

		const finish = () => {
			if (finished) return;

			waitUntilCollapsed(panel, () => {
				if (finished) return;
				finished = true;
				clearConceal(panel);
				panel.hidden = true;
			}, deadline);
		};

		panel._accordionOnEnd = (event) => {
			if (event.target !== panel) return;
			if (event.propertyName !== "grid-template-rows") return;
			finish();
		};

		requestAnimationFrame(() => {
			panel.addEventListener("transitionend", panel._accordionOnEnd);
			panel._accordionConcealTimer = window.setTimeout(
				finish,
				collapseMs + COLLAPSE_BUFFER_MS,
			);
		});
	};

	window.AccordionPanel = {
		COLLAPSE_MS,
		EXPAND_MS,
		reveal,
		conceal,
	};
})();
